import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/TestimonialsCarouselClient.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
